export var link = function (text, attrs) {
    return "[" + text + "|" + attrs.href + "]";
};
//# sourceMappingURL=link.js.map